import React, { Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "../../helpers/http";
import Auth from "../../auth/Auth";
import { useDispatch, useSelector } from "react-redux";
import {
  getCartData,
  getDisplayPrice,
  getFilteredBill,
  handleEditDish,
} from "../../helpers/help";
import { updateFullScreenLoader } from "../../redux/actions/authActions";
import AddCartItem from "../modals/AddCartItem";
// import TipSection from "../common/TipSection";

const MyCart = () => {
  const { isCartItemUpdated, viewCartData, cartItems } = useSelector(
    (state) => state.cart
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const keysToHide = ["Blessings Discount"];

  useEffect(() => {
    getCartData();
  }, [isCartItemUpdated]);

  const updateQuantity = (key, value) => {
    if (key === "decrease" && value.dishQuantity === 0) return; //Quantity should not be zero of added cart item.
    const data = cartItems.find((item) => item.cartId === value.cartId);

    let newQuantity = value.dishQuantity;

    const apiData = {
      udId: Auth.userInfo()?.udId,
      outletId: viewCartData.dishes?.outletDetails.outletId,
      quantity: key === "increase" ? ++newQuantity : --newQuantity,
      cartId: data.cartId,
      customisationId: JSON.stringify(data.customisation),
      spl_instruction: data.spl_instruction,
    };

    dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "POST",
        url: `updateCart`,
        isSecure: true,
        body: apiData,
      },
      (res) => {
        if (res.error === "false") {
          getCartData();
        }
        dispatch(updateFullScreenLoader(false));
      }
    );
  };

  const goToCheckOut = () => {
    navigate("/checkout");
  };

  const handleDeleteDish = (dishItem) => {
    const apiData = {
      udId: Auth.userInfo()?.udId,
      // outletId: viewCartData.dishes?.outletDetails.outletId,
      // quantity: 0,
      cartId: dishItem.cartId,
    };
    dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "POST",
        url: `delete-cart-item`,
        isSecure: true,
        body: apiData,
      },
      (res) => {
        if (res.error === "false") {
          getCartData();
        }
        dispatch(updateFullScreenLoader(false));
      }
    );
  };

  useEffect(() => {
    if (!Auth.isUserAuthenticated()) {
      navigate("/");
      return;
    }
  }, []);
  return (
    <>
      {/* <main>
        <div className="restaurant_inner_bg needmin-hmain">
          <div className="cus_container">
            <h1 className="head1 text-center">My Cart</h1>
          </div>
        </div>
      </main> */}
      <div className="cart-table">
        <div className="cus_container">
          <div className="htitile"><h4 className="head4 mb-4">My Cart</h4></div>
          {viewCartData.dishes ? (
            <div className="bg-shadow">
              <h4 className="head4">Boomerang Only</h4>
              {/* <p>Ready in 25-35 min</p> */}
              <div className="responsive-table">
                <table>
                  <thead>
                    <tr>
                      <th width="40%">Item</th>
                      <th width="20%">Unit Price</th>
                      <th width="20%">Quantity</th>
                      <th width="10%">Total</th>
                      {/* <th width="10%">Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {viewCartData?.dishes?.dishes.map((dishItem) => {
                      return (
                        <tr key={`cart-id-${dishItem.cartId}`}>
                          <td>
                            <h4 className="text-break">{dishItem?.dishName}</h4>
                            {/* <span>Cheese Dip</span> */}
                            {dishItem.dishCustomisation.map(
                              (dishCustomisationItem) => (
                                <Fragment
                                  key={`customizableId-${dishCustomisationItem.customizableId}`}
                                >
                                  {dishCustomisationItem.customizableDishItems.map(
                                    (customizableDish) => (
                                      <Fragment
                                        key={`elementId-${customizableDish.elementId}`}
                                      >
                                        {!!customizableDish.isSelected && (
                                          <span className="txt mb-1 light_b ps-2 text-break">
                                            {customizableDish.elementName}
                                          </span>
                                        )}
                                      </Fragment>
                                    )
                                  )}
                                </Fragment>
                              )
                            )}
                            {/* <span><sup>*</sup> Less Spicy Please</span> */}
                            {dishItem.spl_instruction && (
                              <span className="ps-2 d-flex">
                                <p className="mb-0 me-1 grayS">Notes:</p>
                                <p className="txt mb-0 grayC text-break">{dishItem.spl_instruction}</p>
                              </span>
                            )}
                          </td>
                          <td>${dishItem?.dishPrice}</td>
                          <td className="">
                            <div className="d-flex align-items-center">
                              <span
                                className="me-2 pointer"
                                name="minus"
                                value="minus"
                                onClick={() =>
                                  updateQuantity("decrease", dishItem)
                                }
                              >
                                <img
                                  src="./assets/img/minusTbl.svg"
                                  alt="filter"
                                  className="filterd-flex align-items-center"
                                />
                              </span>
                              <span className="me-2">
                                {" "}
                                {dishItem.dishQuantity}
                              </span>
                              <span
                                className="me-2 pointer"
                                name="plus"
                                onClick={() =>
                                  updateQuantity("increase", dishItem)
                                }
                              >
                                <img
                                  src="./assets/img/addTbl.svg"
                                  alt="filter"
                                  className="filter d-flex align-items-center"
                                />
                              </span>
                            </div>
                          </td>
                          <td>{getDisplayPrice(dishItem.dishTotal)}</td>
                          <td className="">
                            {/* <div className="d-flex">
                              <img
                                src="./assets/img/green-edit-icon.svg"
                                className="pointer"
                                onClick={() => handleEditDish(dishItem)}
                                alt="edit icon"
                              />
                              <img
                                src="./assets/img/delete-icon.svg"
                                className="pointer"
                                onClick={() => handleDeleteDish(dishItem)}
                                alt="delete icon"
                              />
                            </div> */}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="total-cart-price">
                <h4>Cart Total</h4>
                {/* {viewCartData.dishes?.billTotals.map(
                  (billCategory) =>
                    getFilteredBill(billCategory.displayKey) && (
                      <p
                        key={`${billCategory.displayKey}-${billCategory.displayValue}`}
                        className="d-flex justify-content-between"
                      >
                        <span>{`${billCategory.displayKey}:`}</span>
                        <b>{billCategory.displayValue ? billCategory.displayValue.charAt(0) + Number(billCategory.displayValue.split("$")[1]).toFixed(2) : billCategory.displayValue}</b>
                      </p>
                    )
                )} */}
                {viewCartData.dishes?.billTotals.map(
                  (billCategory) =>
                    getFilteredBill(billCategory.displayKey) &&
                    billCategory.displayKey !== "Blessings Discount" && (  // Exclude "Blessings Discount"
                      <p
                        key={`${billCategory.displayKey}-${billCategory.displayValue}`}
                        className="d-flex justify-content-between"
                      >
                        <span>{`${billCategory.displayKey}:`}</span>
                        <b>{billCategory.displayValue ? billCategory.displayValue.charAt(0) + Number(billCategory.displayValue.split("$")[1]).toFixed(2) : billCategory.displayValue}</b>
                      </p>
                    )
                )}
                {/* <TipSection /> */}
                <button className="checkout-btn" onClick={goToCheckOut}>
                  Proceed to Checkout
                </button>
              </div>
            </div>
          ) : (
            <h3 className="text-center">No Cart Items</h3>
          )}
        </div>
      </div>
      <AddCartItem outletId={viewCartData.dishes?.outletDetails.outletId} />
    </>
  );
};

export default MyCart;
